import { NavLink } from "react-router-dom";

const tabs: { to: string; label: string; icon: string; end?: boolean }[] = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category", label: "分类", icon: "ri-layout-grid-line" },
  { to: "/search", label: "搜索", icon: "ri-search-line" },
  { to: "/about", label: "关于", icon: "ri-information-line" },
];

export default function MobileTabBar() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden"
      aria-label="移动端底部导航"
    >
      <ul className="grid grid-cols-4">
        {tabs.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-xs transition-colors cursor-pointer ${
                  isActive ? "text-primary-600" : "text-foreground-500"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <i className={`${tab.icon} text-xl`} aria-hidden="true"></i>
                  <span className="font-label">{tab.label}</span>
                  <span
                    className={`h-0.5 w-5 rounded-full transition-colors ${
                      isActive ? "bg-accent-500" : "bg-transparent"
                    }`}
                  ></span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}